export default __webpack_public_path__ + "static/IBM-Plex-Mono-Regular-12ead37cece64fd8fab042e14a60e810.woff";